import { Component, ViewChild } from '@angular/core';
import { Nav, Platform, ToastController, IonicApp, AlertController, App } from 'ionic-angular';
import { StatusBar } from '@ionic-native/status-bar';
import { SplashScreen } from '@ionic-native/splash-screen';
import { Subscription } from 'rxjs';
import { BranchProvider } from '../providers/analytics/branch';
import { APP_CONFIG, Env } from '../environment';
import { ResourceProvider } from '../providers/resource/resource';
import { FormControlProvider } from '../providers/formbuilder/formcontrol';
import { HttpProvider } from '../providers/http/http';
import { LoggerProvider, LoggerEvent } from '../providers/logger/logger';
import { Device } from '@ionic-native/device';
import { AppVersion } from '@ionic-native/app-version';
import { TranslateService } from '@ngx-translate/core';
import { ConfigProvider } from '../providers/config/config';
import { StorageProvider } from '../providers/storage/storage';
import { MarketingProvider } from '../providers/marketing/marketing';
import { LoadingProvider } from '../providers/loading/loading';
import { StorageType } from '../model/types/storage-type';
import { FeatureFlagTypes } from '../model/types/feature-flag-types';
import { Icons } from '../model/models/customIcons';
import { RouteProvider } from '../providers/route/route';
import { RmtHeaderComponent } from '../components/rmt-header/rmt-header';
import { SegmentProvider } from '../providers/analytics/segment';
import { AccountProvider } from '../providers/myria/account-provider';
import { LoginProvider } from '../providers/myria/login-provider';
import { IterableProvider } from '../providers/marketing/iterable';
import { ProviderUtilities } from '../providers/provider-utilities';
import { LogRocketProvider } from '../providers/log-rocket/log-rocket';
import {IovationProvider} from '../providers/iovation/iovation';
import { AppVersionProvider } from '../providers/app-version/app-version';
import { UtilsProvider } from '../providers/myria/utils-provider';
import { FirebaseAnalyticsProvider } from '../providers/analytics/firebase-analytics';
import { AuthProvider } from '../providers/authorization';
import { OnfidoProvider } from '../providers/myria/onfido-provider';
import { RmtPopupComponent } from '../components/rmt-popup/rmt-popup';
import { SegmentLocationNames } from '../model/types/analytics.const';
import { Keyboard as KeyboardIonic } from '@ionic-native/keyboard';
import { config as ProdConfig } from '../environment/environment.prod';
import * as $ from 'jquery'
import { OrderProvider } from '../providers/order/order';
import { KeyboardProvider } from '../providers/keyboard/keyboard';
import { TalsecProvider } from '../providers/talsec/talsec';
import { ScriptProvider } from '../providers/script';
import { PermissionType } from '../pages/permission-tracking/permission-tracking';
import { INavInfo } from '../model/models/layout/nav-info.interface';
import { DeeplinkProvider } from '../providers/marketing/deeplink';
import { FormControlMapper } from '../providers/formbuilder/formcontrol-mapper';
import { PermissionProvider } from '../providers/myria/permission-provider';
import { MissingTransactionInfoType } from '../model/types/missing-transaction-info-type';
import { ForeignIpGeolocationTestOverrides } from '../providers/foreign-ip-geolocation/foreign-ip-geolocation-test-overrides';
import { VueProvider } from '../providers/vue/vue';
import { VueBridgeState } from '../providers/vue/vue-helpers';
import { AppliedFeaturesDiff, HiddenMenuProvider, PASSPHRASE_REGISTRY } from '../providers/hidden-menu/hidden-menu';
import { RmtSnackbarComponent } from '../components/rmt-snackbar/rmt-snackbar';
import { RmtInternalIssueReporterComponent } from '../components/rmt-internal-issue-reporter/rmt-internal-issue-reporter';


declare var IRoot: any;
declare var RiskifiedPlugin: any;

@Component({
  templateUrl: 'app.html',
})
export class MyApp {
  @ViewChild(Nav) nav: Nav;
  networkConnectSubscription: Subscription;
  networkDisconnectSubscription: Subscription;
  currentYear: number = new Date().getFullYear();
  showToast: boolean = false;
  animLoading;
  animLoadingObj;
  preloadPos: number = 10;
  preloadIcons = Icons;
  navRoot = 'PreLoginStoriesPage';
  branchInitTries = 0;
  branchTimeout;
  openingModal;
  initialPushedPage;

  static isfunc;
  constructor(
    private platform: Platform,
    private keyboardProvider: KeyboardProvider,
    private statusBar: StatusBar,
    private splashScreen: SplashScreen,
    private alertCtrl: AlertController,
    private resourceProvider: ResourceProvider,
    private branch: BranchProvider,
    private device: Device,
    private toastCtrl: ToastController,
    private httpProvider: HttpProvider,
    private translateService: TranslateService,
    private appVersion: AppVersion,
    private storageProvider: StorageProvider,
    private loadingProvider: LoadingProvider,
    private marketingProvider: MarketingProvider,
    private formProvider: FormControlProvider,
    private routeProvider: RouteProvider,
    private ionicApp: IonicApp,
    private accountProvider: AccountProvider,
    private loginProvider: LoginProvider,
    private iterable: IterableProvider,
    private segmentProvider: SegmentProvider,
    private logRocketProvider: LogRocketProvider,
    private iovationProvider: IovationProvider,
    private appVersionProvider: AppVersionProvider,
    private orderProvider: OrderProvider,
    private utilsProvider: UtilsProvider,
    private authProvider: AuthProvider,
    private onfidoProvider: OnfidoProvider,
    private app: App,
    private deeplinkProvider: DeeplinkProvider,
    private scriptProvider: ScriptProvider,
    private keyboardIonic: KeyboardIonic,
    private firebaseAnalytics: FirebaseAnalyticsProvider,
    private vueProvider: VueProvider,
    private permissionProvider: PermissionProvider,
    private talsecProvider: TalsecProvider,
  ) {
    // IMPORTANT TO HAVE DEFAULT LANGUAGE SO WE CAN FALLBACK IF TRANSLATION IS MISSING
    let defaultLang = APP_CONFIG.region.defaultLanguageCulture;
    if (APP_CONFIG.featureFlags.lokaliseContent)
      defaultLang = defaultLang.replace('-', '_');
    this.translateService.setDefaultLang(defaultLang);
    this.translateService.addLangs(this.utilsProvider.availableLanguageCultures());
    this.overridePlatformCheck();
    this.initLogrocket(logRocketProvider);
    this.initTalsec();

    FormControlMapper.init(this.translateService);

    APP_CONFIG.contentConfigs = {
      'deliveryMethodNames.name_MobilePayment_To_BF': 'Mobile money',
      'deliveryMethodNames.name_MobilePayment_To_BI': 'Mobile money',
      'deliveryMethodNames.name_MobilePayment_To_BJ': 'Mobile money',
      'deliveryMethodNames.name_MobilePayment_To_BW': 'Mobile money',
      'deliveryMethodNames.name_MobilePayment_To_CD': 'Mobile money',
      'deliveryMethodNames.name_MobilePayment_To_CG': 'Mobile money',
      'deliveryMethodNames.name_MobilePayment_To_CI': 'Mobile money',
      'deliveryMethodNames.name_MobilePayment_To_CM': 'Mobile money',
      'deliveryMethodNames.name_MobilePayment_To_ET': 'Mobile money',
      'deliveryMethodNames.name_MobilePayment_To_GH': 'Mobile money',
      'deliveryMethodNames.name_MobilePayment_To_GM': 'Mobile money',
      'deliveryMethodNames.name_MobilePayment_To_GN': 'Mobile money',
      'deliveryMethodNames.name_MobilePayment_To_GW': 'Mobile money',
      'deliveryMethodNames.name_MobilePayment_To_KE': 'Mobile money',
      'deliveryMethodNames.name_MobilePayment_To_LR': 'Mobile money',
      'deliveryMethodNames.name_MobilePayment_To_LS': 'Mobile money',
      'deliveryMethodNames.name_MobilePayment_To_ML': 'Mobile money',
      'deliveryMethodNames.name_MobilePayment_To_MW': 'Mobile money',
      'deliveryMethodNames.name_MobilePayment_To_MZ': 'Mobile money',
      'deliveryMethodNames.name_MobilePayment_To_RW': 'Mobile money',
      'deliveryMethodNames.name_MobilePayment_To_SL': 'Mobile money',
      'deliveryMethodNames.name_MobilePayment_To_SN': 'Mobile money',
      'deliveryMethodNames.name_MobilePayment_To_SZ': 'Mobile money',
      'deliveryMethodNames.name_MobilePayment_To_TZ': 'Mobile money',
      'deliveryMethodNames.name_MobilePayment_To_UG': 'Mobile money',
      'deliveryMethodNames.name_MobilePayment_To_ZM': 'Mobile money',
      'deliveryMethodNames.name_MobilePayment_To_ZW': 'Mobile money',
      'deliveryMethodNames.name_MobilePayment_To_PE': 'Yape, PLIN',
      'deliveryMethodNames.name_MobilePayment_To_IN': 'Paytm',
      'deliveryMethodNames.name_MobilePayment_To_HR': 'Aircash',
      'deliveryMethodNames.name_MobilePayment_To_BG': 'ePay.bg',
      'deliveryMethodNames.name_MobilePayment_To_MR': 'Bankily',
      'deliveryMethodNames.name_MobilePayment_To_HT': 'Moncash',
      'deliveryMethodNames.name_MobilePayment_To_MG': 'Mobile Money',
      'deliveryMethodNames.name_MobilePayment_To_MA': 'Mobile Money',
      'mobileWalletFavorites.walletIds_To_PK': '117900711,117900511,127079611,127079411,117899311,117899711,117900011,117900111,117899511,117899611,117899411,117899911,117900611',
      'mobileWalletFavorites.walletIds_To_SN': '134393111,133470511,100325811',
      'mobileWalletFavorites.walletIds_To_FJ': '88032711,123443611,143299811,144681311',
      'mobileWalletFavorites.walletIds_To_PH': '143564711,143544111,121615311,121615511,145730411,135574611,123595011,123594911,123840111'
    };

    if (APP_CONFIG.env !== Env.PROD) {
      if (APP_CONFIG.previewFrame)
        $(document.body).addClass('preview-frame');
      // if the keyboard popups the size of the frame should remain the same hence set the minimum size here
      const el: any = document.getElementsByClassName('preview-frame-overlay')[0];
      el.style.minHeight = window.innerHeight + 'px';
    }

    platform.registerBackButtonAction(() => {
      LoggerProvider.info(this, 'Pressed physical back button');

      if (this.showToast) this.platform.exitApp();

      // The internal issue sheet floats above everything, so it must swallow the press first.
      if (RmtInternalIssueReporterComponent.dismissIfOpen()) return;

      const activePortal = this.ionicApp._overlayPortal.getActive();

      // Onboarding is forward-only; RMT5 would pop past it. Must stay above the forward.
      if (this.vueProvider.consumeHardwareBackDuringOnboarding()) {
        return;
      }

      // RMT5 owns the press inside the bridge; it replies HardwareBackUnhandled if stuck.
      if (VueBridgeState.isUserInsideVueBridge && (this.vueProvider.elevateIframe || !activePortal)) {
        this.vueProvider.sendHardwareBack();
        return;
      }

      if (activePortal && activePortal.data && activePortal.data.enableBackdropDismiss) {
        activePortal.dismiss();
        return;
      }

      const navCtrl = this.app.getActiveNavs()[0];
      if (navCtrl) {
        const view = navCtrl.getActive();
        const page = view ? navCtrl.getActive().instance : null;
          if (page && page.handleBack) {
          page.handleBack()
          return;
        }
      }

      if (!RmtHeaderComponent.back()) this.presentToast();
    }, 1);

    this.vueProvider.onHardwareBackUnhandled = () => {
      if (!this.vueProvider.consumeHardwareBackDuringOnboarding()) this.presentToast();
    };

    platform
      .ready()
      .then(async () => {
        await this.initPlatform();

        if (this.platform.is('cordova')) {
          if (this.platform.is('ios')) {
            this.statusBar.styleDefault();
            this.subscribeVueBridgeStatusBar();
          }
          LoggerProvider.info(this, LoggerEvent.Info, 'Hiding the splash screen');
          this.splashScreen.hide();
        }
        await this.initializeAppWideListeners()
        this.orderProvider.initializeAccertify();
        // resources are already initialized in auth.is init() after platform ready (setUserCountry), so don't init them twice
        // formProvider also gets already initialized later

        //TODO!! this.idleActivityProvider.initTimer();
        iovationProvider.loadIovation();

        if (this.animLoadingObj)
          this.animLoadingObj.stop();

        LoggerProvider.info(this, 'Finished initialize app');
      })
      .catch((ex) => {
        LoggerProvider.exception(this, ex, LoggerEvent.GeneralException, 'Failed to initialize app');
        if (this.animLoadingObj)
          this.animLoadingObj.stop();
      });
  }

  private subscribeVueBridgeStatusBar() {
    this.vueProvider.bridgeVisible$.subscribe((visible: boolean) => {
      try {
        if (visible) {
          this.statusBar.styleLightContent();
        } else {
          this.statusBar.styleDefault();
        }
      } catch (ex) {
        LoggerProvider.warning(this, LoggerEvent.GeneralException, `Failed to update status bar style for Vue bridge: ${ex && (ex as any).message ? (ex as any).message : ex}`);
      }
    });
  }

  private overridePlatformCheck() {
    this.platform.ready()
      .then(() => {
        LoggerProvider.info(this, 'READY platform ready !!!');
        LoggerProvider.info(this, `Location: ${window.location.href}`);
        MyApp.isfunc = this.platform.is;
        const testUserAgent = (userAgent, expr: RegExp) =>
          expr.test(userAgent);
        this.platform.is = (platformName: string) => {
          if (MyApp.isfunc.call(this.platform, platformName))
            return true;
          if (platformName === 'ios' || platformName === 'ipad') {
            if (testUserAgent(navigator.userAgent, /Macintosh/i) && MyApp.isfunc.call(this.platform, 'cordova')) {
              return true;
            }
          }
          return false;
        };
      });
  }

  private async initTalsec() {
    try {
      await this.talsecProvider.init();
    } catch (ex) {
      LoggerProvider.exception(this, ex, LoggerEvent.RootDetection, 'Failed to initialize Talsec');
    }
  }

  private async initLogrocket(logRocketProvider: LogRocketProvider) {
    try {
      await this.platform.ready();
      if (this.platform.is("android") && !(<any>window.navigator).connection.addEventListener) {
        LoggerProvider.info(this, 'Navigator connection missed addEventListener - old browser verison ?');
        (<any>window.navigator).connection.addEventListener = () => {
        };
      }
      // Not awaited: init() now waits for the page 'load' event before LogRocket inserts its CDN
      // script (LogRocketProvider.afterPageLoad). Logging must start whether or not that CDN answers,
      // so only the capped wait below depends on it.
      logRocketProvider.init()
        .then(() => LoggerProvider.info(this, 'Logrocket initialized successfully'))
        .catch((ex) => LoggerProvider.exception(this, ex, LoggerEvent.PageException, 'Failed to initialize Logrocket'));
    }
    catch (ex) {
      LoggerProvider.exception(this, ex, LoggerEvent.PageException, 'Failed to initialize Logrocket');
    }
    await new Promise(async(resolve) => {
      window.setTimeout(() => {
        LoggerProvider.info(this, 'Logrocket not initialized in time (page load pending?) - starting log without it');
        resolve(true);
        resolve = null;
      }, 5000);
      await this.logRocketProvider.logRocketInitPromise;
      if (resolve)
        resolve(true);
    });
    LoggerProvider.info(this, 'Start log');
    LoggerProvider.startLog(this.httpProvider); // start log after Logrocket initialized to ensure everything get logged to Logrocket
  }

  private presentHiddenMenuTransitionMessages(diff: AppliedFeaturesDiff) {
    for (const p of diff.newlyEnabled) {
      const feature = PASSPHRASE_REGISTRY[p];
      if (feature) RmtSnackbarComponent.present(`${feature.name} is now enabled.`);
    }
    for (const p of diff.newlyDisabled) {
      const feature = PASSPHRASE_REGISTRY[p];
      if (feature) RmtSnackbarComponent.present(`${feature.name} is now disabled.`);
    }
  }

  async initPlatform() {
    this.navRoot = 'PreLoginStoriesPage';
    if (this.platform.is('cordova')) {
      try {
        HttpProvider.version = await this.appVersion.getVersionNumber();
        LoggerProvider.appVersion = HttpProvider.version;
        LoggerProvider.info(this, 'OneApp Version: ' + HttpProvider.version);
      } catch (ex) {
        LoggerProvider.exception(this, ex, LoggerEvent.GeneralException, 'Unable to get version number');
      }

      const deviceId = await this.resolveDeviceId();
      LoggerProvider.appInfo = {
        ...LoggerProvider.appInfo,
        deviceId: deviceId,
        deviceModel: this.device.model,
        devicePlatform: this.device.platform,
        deviceVersion: this.device.version,
        deviceManufacturer: this.device.manufacturer,
        deviceSerial: this.device.serial,
      };
      LoggerProvider.uuid = deviceId;
    } else {
      LoggerProvider.appInfo = {
        ...LoggerProvider.appInfo,
        deviceModel: 'Browser',
      };
      LoggerProvider.uuid = ''; // will be set later with the session ID
    }
    // Apply staged hidden menu features before test version check and first API call
    try {
      const storedFeatures = await this.storageProvider.getJson(StorageType.HiddenMenuFeatures);
      const lastApplied = await this.storageProvider.getJson(StorageType.HiddenMenuLastAppliedFeatures);
      const stored = Array.isArray(storedFeatures) ? storedFeatures : [];
      const previous = Array.isArray(lastApplied) ? lastApplied : [];
      const diff = HiddenMenuProvider.applyFromStorage(stored, previous);
      if (stored.length > 0) {
        LoggerProvider.info(this, `Applied hidden menu features: ${stored.join(', ')}`);
      }
      this.storageProvider.setJson(StorageType.HiddenMenuLastAppliedFeatures, stored);
      if (diff.newlyEnabled.length > 0 || diff.newlyDisabled.length > 0) {
        setTimeout(() => this.presentHiddenMenuTransitionMessages(diff), 2000);
      }
    } catch (ex) {
      LoggerProvider.exception(this, ex, LoggerEvent.GeneralException, 'Failed to apply hidden menu features');
    }

    try {
      await UtilsProvider.loadFeatureFlagOverrides(this.storageProvider);
      const overrideKeys = Object.keys(UtilsProvider.featureFlagOverrides);
      if (overrideKeys.length > 0) {
        LoggerProvider.info(this, `Applied feature flag overrides: ${overrideKeys.join(', ')}`);
      }
    } catch (ex) {
      LoggerProvider.exception(this, ex, LoggerEvent.GeneralException, 'Failed to load feature flag overrides');
    }

    ForeignIpGeolocationTestOverrides.load(this.storageProvider)
      .catch((ex) => LoggerProvider.exception(this, ex, LoggerEvent.GeneralException, 'Failed to load foreign IP test overrides'));

    LoggerProvider.info(this, 'Backend Version: ' + HttpProvider.minVersion);
    this.httpProvider.checkTestVersion();

    if(this.platform.is('cordova')) {
      this.firebaseAnalytics.initAnalytics();
    }
    LoggerProvider.generateSessionId();
    if (!this.platform.is('cordova')) {
      LoggerProvider.uuid = await this.storageProvider.get(StorageType.VirtualUuid);
      if (!LoggerProvider.uuid) {
        LoggerProvider.uuid = 'Virtual' + LoggerProvider.sessionId;
        this.storageProvider.set(StorageType.VirtualUuid, LoggerProvider.uuid);
      }
      LoggerProvider.globalSessionId = null;
      LoggerProvider.generateSessionId();
    }

    if(this.platform.is('cordova')){
      const data = {
        session: LoggerProvider.globalSessionId,
        shopUrl: "secure.riamoneytransfer.com"
      }
      try {
        RiskifiedPlugin.start(data, (response: any) => {
          LoggerProvider.info(this, 'Started Riskified', response);
        });
        LoggerProvider.info(this, 'Started riskified');
      } catch (ex) {
        LoggerProvider.exception(this, ex, LoggerEvent.ProviderException, 'Failed to load Riskified');
      }
    }
    else
      this.scriptProvider.loadRiskifiedBeacon();

    if (HttpProvider.relogging)
      LoggerProvider.info(this, 'Communication not ready because of relogin');
    else {
      HttpProvider.readyResolve(true);
      HttpProvider.readyPromise = null;
      LoggerProvider.info(this, 'Communications ready');
    }

    const countryPromise = this.httpProvider.initAuthCountry();
    this.initializeBranch(); // important initialize Branch before since the deeplinks may have dependencies (i.e. are you logged in in deeplinkParamsHandeler)
    const initResult = await this.httpProvider.initRemittanceAuthToken();
    // Check with Martin
    if (initResult && initResult.refreshResult)
      this.authProvider.login = initResult.refreshResult.Value;

    LoggerProvider.startLog(this.httpProvider);

    if (this.platform.is('cordova')) {
      const rooted = await this.isRooted();
      if (rooted) {
        if (APP_CONFIG.env === Env.PROD) {
          const alert = this.alertCtrl.create({
            message: "App can't run on a rooted device",
            enableBackdropDismiss: false,
            buttons: [
              {
                text: 'Exit',
                handler: () => {
                  this.platform.exitApp();
                },
              },
            ],
          });
          alert.present();
          return;
        } else LoggerProvider.warning(this, LoggerEvent.RootDetection, 'Skipped root detection on non-production build');
      }
    }

    ConfigProvider.startConfig(this.httpProvider, this.platform);
    this.marketingProvider.startMarketing();

    if (this.platform.is('cordova')) {
      this.iterable.onNotificationOpen();
      this.iterable.onCustomActionClick();
    } else {
      // const mockPushNotificationResponse = {uri: "action://links.riamoneytransfer.com/a/deeplink?id=US1935735755&page=OrderDetailsPage", scheme: "action", host: "links.riamoneytransfer.com", path: "/a/deeplink", query: "id=US1935735755&page=OrderDetailsPage"};
      // this.iterable.onNotificationOpen(mockPushNotificationResponse);
      LoggerProvider.info(this, "Iterable handeller can't be registered on browser");
    }

    // this.keyboardIonic.onKeyboardShow().subscribe(() => {
    //   LoggerProvider.debug(this, 'Show keyboard');
    //   $(document.body).addClass('global-keyboard-visible');
    // });

    // this.keyboardIonic.onKeyboardHide().subscribe(() => {
    //   LoggerProvider.debug(this, 'Hide keyboard');
    //   this.keyboardHidden = true;
    //   $(document.body).removeClass('global-keyboard-visible');
    // });

    // wait until the init country has been properly set to avoid a racing conditions since further logic eventually depends on it
    await countryPromise;

    // Insert the Vue iframe only after the page 'load' event, so a slow iframe can never hold up
    // the WebView's load (Android "connection to the server was unsuccessful" dialog).
    // Not awaited: callers of initPlatform() must not be delayed by the page load.
    LogRocketProvider.afterPageLoad().then(() => {
      window.setTimeout(() => {
        this.vueProvider.init();
      });
    });
  }

  ngOnInit() {
    // ensure that the animation won't affect the loading of the page
    window.setTimeout(() => {
      this.animLoading = {
        path: 'assets/anims/ria-loader-coin.json',
        autoplay: false,
        loop: true,
      };
    }, 1000);

    this.branch.pspRedirectResult$.subscribe(async (redirectResult: string) => {
      try {
        await this.vueProvider.init();
        LoggerProvider.info(this, 'RMT5 PSP redirect (Branch): forwarding to Vue iframe');
        await this.vueProvider.navigate('AdyenProcessingPage', '', { query: { redirectResult } }, null, true);
        LoggerProvider.info(this, 'RMT5 PSP redirect (Branch): forward complete');
      } catch (ex) {
        LoggerProvider.exception(this, ex, LoggerEvent.PageException, 'RMT5 PSP redirect (Branch): failed to forward to Vue iframe');
      }
    });
  }

  async isRooted() {
    return new Promise((resolve) => {
      try {
        if (IRoot) {
          IRoot.isRooted(
            (rooted) => {
              if (!rooted) {
                LoggerProvider.info(this, 'Passed root detection');
                resolve(false);
              } else {
                LoggerProvider.error(this, LoggerEvent.RootDetection, 'Device is rooted');
                resolve(true);
              }
            },
            (error) => {
              LoggerProvider.error(this, LoggerEvent.RootDetection, 'Root detection failed', error);
              resolve(true);
            }
          );
          return;
        } else LoggerProvider.error(this, LoggerEvent.RootDetection, 'Root detection not available');
      } catch (ex) {
        LoggerProvider.exception(this, ex, LoggerEvent.RootDetection, 'Root detection exception');
      }
      resolve(true);
    });
  }

  preloadingIcons() {
    this.preloadPos += 10;
    if (this.preloadPos < this.preloadIcons.length)
      window.setTimeout(() => {
        this.preloadingIcons();
      }, 100);
  }

  handleAnimation(anim) {
    this.animLoadingObj = anim;
    anim.play();
    this.loadingProvider.setAnim(anim);
  }

  async initializeAppWideListeners() {
    this.segmentProvider.init();
    if (this.animLoadingObj)
      this.animLoadingObj.pause();
    await this.checkModals();
    if (this.animLoadingObj)
      this.animLoadingObj.play();
    this.initAppNav();
  }

  async checkModals() {
    await this.routeProvider.transitionPromise;
    if (!APP_CONFIG.automationTest) {
      await this.checkATT();
    } else {
      LoggerProvider.info(this, 'ATT permission check skipped in automation test');
    }
    this.checkAndHandlePermissions();
  }

  async checkAndHandlePermissions() {
    // If user previous had allowed the permisison then update Iterable
    this.permissionProvider.checkNotificationPermission().then((value) => {
      if (value == true && this.platform.is('cordova')) {
        this.iterable.registerForPush();
      }
    });
  }

  async checkATT() {
    return new Promise<boolean>(async (resolve) => {
      try {
        let checked = await this.permissionProvider.checkATTPermission();
        if (checked && this.platform.is('android')) {
          // since firebaseConsentDenied was called incorrectly for some Android users if we see that they don't have the permission 
          // we will give it a retry so that users who opted in before can optin successfully
          const retried = await this.storageProvider.get(StorageType.ConsentIDFARetried);
          const granted = await this.storageProvider.get(StorageType.ConsentIDFAPermission);
          LoggerProvider.info(this, `Checking if retry is needed for ATT ${retried}/${granted}}`);
          if (granted !== 'true' && retried !== 'true') {
            LoggerProvider.info(this, 'Retry ATT');
            checked = false;
          } else if (granted !== 'true' && this.utilsProvider.isConsentModeEnabled()
            && await this.storageProvider.get(StorageType.ConsentIDFAReasked) !== 'true'
            && await this.utilsProvider.getFeatureFlagData(FeatureFlagTypes.AndroidConsentReaskEnabled) === true) {
            // 3.106+ saved Android Accept as Reject, ask those users once more
            LoggerProvider.info(this, 'Re-ask ATT');
            checked = false;
          }
        }
        this.storageProvider.set(StorageType.ConsentIDFARetried, 'true');
        if (checked == false) {
          if (this.utilsProvider.isConsentModeEnabled() === false && this.platform.is('android')) {
            await this.permissionProvider.requestATTPermission();
            resolve(true);
          } else {
            this.showOpeningModal(this.routeProvider.pages.PermissionTrackingPage, {
              permissionType: PermissionType.ATT
            }, () => {
              // any answer given on a fixed build is final, so only pre-fix answers get the re-ask
              this.storageProvider.set(StorageType.ConsentIDFAReasked, 'true');
              resolve(true);
            });
            return;
          }
        }else {
          resolve(true);
          LoggerProvider.info(this, 'ATT has been checked already');
        }
      } catch (ex) {
        LoggerProvider.exception(this, ex, LoggerEvent.ProviderException, 'Failed to get Storage provider');
      }
      resolve(true);
    });
  }

  async initializeBranch() {
    const profiler = LoggerProvider.startProfiler();
    
    if(!this.platform.is('cordova')) { // If we are running the app on browser
      await this.branch.initSdk(this.authProvider, this.onfidoProvider);
      return;
    }

    const isInit = await this.iterable.isInit();
    if (isInit) {
      // initialize the SDK with our configuration and hook into the app store(s) referrer API for install tracking
      clearTimeout(this.branchTimeout);
      await this.branch.initSdk(this.authProvider, this.onfidoProvider);
      LoggerProvider.profileLogEntry(profiler, this, 'Branch initialized');
    } else {
      this.branchInitTries++;
      LoggerProvider.profileLogEntry(profiler, this, `Branch is waiting for Iterable to initialize: try no. ${this.branchInitTries}`);
      if (this.branchInitTries < 10) {
        if(this.branchTimeout)
          clearTimeout(this.branchTimeout);
        this.branchTimeout = setTimeout(
          ()=> this.initializeBranch(), 500);
      }
      else {
        // initialize the SDK with our configuration and hook into the app store(s) referrer API for install tracking
        await this.branch.initSdk(this.authProvider, this.onfidoProvider);
        LoggerProvider.profileLogEntry(profiler, this, `Branch initialized without waiting for Iterable after ${this.branchInitTries} tries`);
        clearTimeout(this.branchTimeout);
      }
    }

  }

  presentToast() {
    const toast = this.toastCtrl.create({
      message: 'Press again to exit',
      duration: 3000,
      position: 'bottom',
    });

    toast.onDidDismiss(() => {
      this.showToast = false;
    });

    this.showToast = true;
    toast.present();
  }

  async initAppNav() {
    RouteProvider.ready = true;
    LoggerProvider.info(this, 'Init app nav');

    // i.e. http://localhost:8100/#/result-psp?sessionId=CSA0E91A5D7E5F0F96&redirectResult=X3XtfGC7%21H4sIAAAAAAAA%2F21SYU...
    const pspRedirect = (window.location && window.location.href && window.location.href.indexOf('/#/result-psp?') >= 0);

    // RMT5 (Vue iframe) PSP redirect — clones the legacy `/#/result-psp?` flow.
    // i.e. http://localhost:8100/#/wallet/payment/processing?redirectResult=...
    const rmt5PspRedirect = (window.location && window.location.href && window.location.href.indexOf('/#/wallet/payment/processing?') >= 0);


    // still logged in, then let's resume
    if (HttpProvider.hasAuthCustomerId()) {
      const result = await this.authProvider.initializeUser(false, false, false, true, true);
        if (rmt5PspRedirect) {
          LoggerProvider.info(this, 'RMT5 PSP redirect');
          let redirectResult: string | undefined;
          let queries = window.location.href.split('?');
          if (queries && queries.length >= 2) {
            queries = queries[1].split('&');
            if (queries) {
              for (const part of queries) {
                if (part.indexOf('redirectResult=') === 0)
                  redirectResult = decodeURIComponent(part.replace('redirectResult=', ''));
              }
            }
          }

          if (redirectResult) {
            // Clear the hash so a refresh does not re-trigger redirect handling.
            window.history.replaceState({}, '', '/');
            try {
              await this.vueProvider.init();
              LoggerProvider.info(this, 'RMT5 PSP redirect: forwarding to Vue iframe');
              await this.vueProvider.navigate('AdyenProcessingPage', '', { query: { redirectResult } }, null, true);
              LoggerProvider.info(this, 'RMT5 PSP redirect: forward complete');
            } catch (ex) {
              LoggerProvider.exception(this, ex, LoggerEvent.PageException, 'RMT5 PSP redirect: failed to forward to Vue iframe');
            }
            return;
          }

          LoggerProvider.error(this, LoggerEvent.PageException, 'Incomplete result for RMT5 PSP: ' + window.location.href);
        }

      if (result) {
        if (pspRedirect) {
          LoggerProvider.info(this, 'PSP redirect');
          const order = await this.orderProvider.getPendingOrder();
          if (order) {
            let redirectResult;
            let queries = window.location.href.split('?');
            if (queries && queries.length >= 2) {
              queries = queries[1].split('&');
              if (queries) {
                for (const part of queries) {
                  if (part.indexOf('redirectResult=') === 0)
                    redirectResult = decodeURIComponent(part.replace('redirectResult=', ''));
                }
              }
            }

            if (redirectResult) {
              this.orderProvider.setCurrentOrder(order, false);
              this.orderProvider.removePendingOrder();
              const redirectOrder = { ...order };
              redirectOrder.pspPaymentSessionData = {
                data: redirectResult,
                additionalDetails: true
              };
              LoggerProvider.info(this, 'Navigate back to PSP');
              this.routeProvider.setRoot(this.routeProvider.pages.SendSummaryPage, {
                redirectOrder
              });
              return;
            } else
              LoggerProvider.error(this, LoggerEvent.PageException, 'Incomplete result for PSP: ' + window.location.href);
          } else
            LoggerProvider.error(this, LoggerEvent.PageException, 'Order missing for PSP !');
        } else {
          const transactionId = await this.storageProvider.get(StorageType.PendingRedirectTransactionId);
          this.storageProvider.remove(StorageType.PendingRedirectTransactionId);
          if (transactionId) {
            LoggerProvider.info(this, `Has pending redirect order ${transactionId}`);
            const maxAge = 60 * 10; // 10 minutes
            const order = await this.orderProvider.getPendingOrder(maxAge);
            if (order && order.transactionId && order.transactionId.toString() === transactionId.toString()) {
              LoggerProvider.info(this, 'Resume pending redirect order');
              this.orderProvider.setCurrentOrder(order, false);
              this.orderProvider.removePendingOrder();
              this.routeProvider.setRoot(this.routeProvider.pages.SendSummaryPage, {
                redirectError: MissingTransactionInfoType.RequiresPayerAuthenticationCheck
              });
              return;
            } else if (order)
              LoggerProvider.info(this, `Pending order does not match pending redirect order number: ${order.transactionId}`);
            else
              LoggerProvider.info(this, 'Has no pending order');
          }
        }

        LoggerProvider.info(this, 'Resume login');
        this.authProvider.navigateLogin(null, SegmentLocationNames.Resume, false);

        // ensure to load typical resources with a bit delay not to make the intial page load slower
        window.setTimeout(() => {
          this.resourceProvider.ensureInitializedResources();
          this.formProvider.getFieldsRegistration();
        }, 1000);
        return;
      } else
        RmtPopupComponent.showErrorWithLogTranslation("page.errorPage.automaticLoginFailed");
    }

    if (pspRedirect)
      LoggerProvider.error(this, LoggerEvent.PageException, 'Redirect for PSP ignored (not logged in anymore ?)');

    let firstPage = false;
    if (this.routeProvider.getLastRootPage() !== 'unknown' && !this.routeProvider.getLastPushedPage()) {
      LoggerProvider.info(this, 'First pushed page - go to root');
      firstPage = true;
    } else if (this.openingModal && this.initialPushedPage) {
      LoggerProvider.info(this, `A page has been pushed already before the opening modals (${this.initialPushedPage}) - hence skip root page`);
      firstPage = false;
    } else if (this.openingModal && this.routeProvider.getLastPushedPage() && this.routeProvider.getLastPushedPage().page === this.openingModal.page) {
      LoggerProvider.info(this, 'First pushed page after modals - go to root');
      firstPage = true;
    }
    if (firstPage) this.goToRootPage();

    await this.routeProvider.waitForTransitions();
    this.vueProvider.preConnectVueBridgeInBackground();
  }

  async goToRootPage() {
    this.routeProvider.setRoot({ page: this.navRoot }, { skipLogout: true }); // we just started so don't need to logout again
  }

  setEnvToProd(){
    for (const env in ProdConfig) {
      APP_CONFIG[env] = ProdConfig[env];
    }
  }

  showOpeningModal(page: INavInfo, params = {}, returnFunc: Function | null = null) {
    const lastPushedPage = this.routeProvider.getLastPushedPage();
    if (lastPushedPage) {
      // skip modal page as the initial pushed page as the modals are temporary and hence should not be considered as a initial pushed page (otherwise the set root navigation could be skipped)
      if (!lastPushedPage.isModalPage) {
        LoggerProvider.info(this, `Set last pushed page to ${lastPushedPage.page}`)
        this.initialPushedPage = lastPushedPage;
      } else
        LoggerProvider.info(this, `Ignore last pushed page ${lastPushedPage.page} as it is a modal page`);
    }
    this.openingModal = page;
    return this.routeProvider.openModal(page, params, returnFunc);
  }

  private async resolveDeviceId(): Promise<string> {
    return this.device.uuid;

    //Commenting out the change done in OM-14170. Since now we'll be moving to Amplitude Actions.
    // Amplitude Classic (PROD) uses the  Android Advertising ID (AAID) by default.
    // if (!this.platform.is("android")) {
    //   return this.device.uuid;
    // }
    // try {
    //   const info = await (window as any).cordova.plugins.idfa.getInfo();
    //   return info.trackingLimited ? this.device.uuid : info.aaid;
    // } catch(error) {
    //   LoggerProvider.error(this, LoggerEvent.IDFAPluginException, error);
    //   LoggerProvider.info(this, "Fall back to device UUID.");
    //   return this.device.uuid;
    // }
  }
}



// WEBPACK FOOTER //
// ./src/app/app.component.ts